var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"g-loading"},[_c('div',{staticClass:"g-loading__frame-wrapper"},[_c('div',{staticClass:"g-loading__frame"},[_c('img',{attrs:{"src":require('@/assets/icon/loading.gif')}})])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }